module.exports = __webpack_public_path__ + "img/person.ba9c735d.png";